// Simulated AI Agent responses — no backend/real API call. Keyed by a
// loose "intent" match against the user's message/action so the demo still
// feels responsive, matching the mockup's UX without a live Anthropic call.

const REPLIES = {
  conflicts: `Here's the resolution plan:

1. **Ms. Aishah Binte Omar** — move TG201 to Classroom C04 (60% util) on Tuesday, keep her original 10:00 slot for AI-TG101 only.
2. **AI-TG101** — reschedule to Thursday 09:30 in Classroom B06 (45% util), well clear of her other commitments.
3. **Classroom A12** — redirect AI-TM201's overlapping request to B03 (55% util) to relieve the 88% pressure.

Applying these three changes clears both conflicts with no other lecturer or room affected.`,
  description: `**AI-TM401 — Smart Tourism Destination Management with AI**

This Master's-level elective equips working tourism professionals with the skills to deploy AI across destination planning. Over 60 hours, participants explore visitor analytics, smart destination platforms, and predictive demand modelling, learning to translate raw visitor data into actionable planning decisions.

The module aligns with STB's Smart Nation initiatives and closes with a critical look at ethical AI use in public tourism spaces — balancing innovation with visitor privacy and inclusive access. Ideal for planners, product owners, and destination marketers ready to lead Singapore's next generation of AI-enabled tourism.`,
  optimise: `Three rebalancing moves:

1. **Shift 2 AI-track hours from Dr. Priya Nair to Mr. Kevin Ng** (currently 10/20h) — brings both specialists closer to a sustainable 14–16h band.
2. **Redirect new bookings away from A12 (88%) and C01 (85%)** toward B03 (55%), B06 (45%), and B08 (50%) — spreads Block B's spare capacity.
3. **Watch Ms. Aishah Binte Omar** — she's at 18/20h; avoid adding further guide-trainer sessions to her line this term.

These three moves bring average utilisation into the 65–75% target band without displacing any locked plans.`,
  compliance: `**Compliance check — AY2026 S1**

- ✅ STB: All three Tourist Guiding modules (TG101/TG201/TG301) have licensed trainers assigned (Pillai, Omar, Lim).
- ⚠️ SkillsFuture: AI-TM301 and SM-TM201 should be re-verified against the current WSQ framework before their SSF eligibility is confirmed for the next intake.
- ⚠️ EduTrust: PLN-003 (AI in Tourism Suite) still has 2 unresolved conflicts — it cannot be submitted for Head review until those clear.

Recommended action: resolve PLN-003's conflicts first, then re-run the WSQ check on the two flagged AI/Social courses.`,
  default: `I can help with scheduling conflicts, course descriptions, workload optimisation, and STB/EduTrust/SkillsFuture compliance checks for TMIS's AY2026 Semester 1 deployment. What would you like me to look into?`,
};

function matchIntent(text) {
  const t = text.toLowerCase();
  if (t.includes('conflict') || t.includes('double-book') || t.includes('resolve')) return 'conflicts';
  if (t.includes('description') || t.includes('draft') || t.includes('content') || t.includes('roadmap')) return 'description';
  if (t.includes('optimi') || t.includes('workload') || t.includes('rebalanc')) return 'optimise';
  if (t.includes('compliance') || t.includes('stb') || t.includes('edutrust') || t.includes('skillsfuture') || t.includes('ssf')) return 'compliance';
  return 'default';
}

export function getSimulatedReply(text) {
  return REPLIES[matchIntent(text)] || REPLIES.default;
}

export function getActionReply(action) {
  return REPLIES[action] || REPLIES.default;
}
